/**
 * 图片 URL 解析：库内存相对路径（如 Uploads/signatures/xxx.png），
 * 前端统一拼 /apiserve/crmapi/ 前缀；http(s)/绝对路径原样返回。
 */
export function resolveImageUrl(p) {
  if (!p) return ''
  if (/^https?:\/\//i.test(p) || p.startsWith('/')) return p
  return '/apiserve/crmapi/' + p
}
